import { NgModule }      from '@angular/core';
import { CommonModule }  from '@angular/common';
import { FormsModule} from '@angular/forms';
import { Routes, RouterModule }  from '@angular/router';



import {Client} from "./client.page";

export const routes: Routes = [
    { path: 'client', component: Client },
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        Client
    ]
})

export class ClientModule { }



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/client/client.module.ts